import React from 'react';
import PageWrapper from '../../../components/page-wrapper/page-wrapper';
import BlogEditor from '../../../components/blog-editor/blog-editor';

const BlogEditorPage = () => {
  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-12">
            <BlogEditor />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default BlogEditorPage;